import { MemoType } from "./MemoEditDialogContent";

export type MemoEditDialogState = {
  pjtId: string;
  tcktTypeCd: string;
  tcktStsTypeCd: string;
  mmTxt: string;
  orgMmTxt: string;
  updateDateTime: string;
  targetIndex: string;
  memoType: MemoType;
  isShow: boolean;
  isEdited: boolean;
};
export type PageNewState =
  | MemoEditDialogState
  | ((prevState: MemoEditDialogState) => MemoEditDialogState);
